export const formatDecimalAmount = (num: number) => {
  if (num.toString().split('.')[1]?.length <= 2) {
    return num;
  } else {
    return parseFloat(num.toFixed(2));
  }
}